module.exports = __webpack_public_path__ + "img/qrcode.f3d4b204.jpg";